<template>
  <li>
    <div role="article" tabindex="-1" class="comment-item">
      <div class="comment-item__perfil-image">
        <div class="nc684nl6">
          <a
            class="comment-item__perfil-image__link"
            href="#"
            role="link"
            tabindex="-1"
          >
            <img :src="crate_by_profile_img_src" class="avatar" alt="avatar" />
          </a>
        </div>
      </div>
      <div class="comment-item__view-comment">
        <div>
          <div class="comment-item__view-comment__message">
            <div class="_680y">
              <div class="_6cuy">
                <div class="container-message-comment">
                  <div class="container-message-comment__c">
                    <div class="comment-link__profile-container">
                      <a class="comment-link" href="#" role="link" tabindex="0">
                        <span class="pq6dq46d">
                          <span class="comment-link-name" dir="auto"
                            >{{ comment.CreatedByUser.FullName }}
                          </span>
                        </span>
                      </a>
                    </div>
                    <div class="comment-message__container">
                      <span dir="auto">
                        <div class="message">
                          <div dir="auto" style="text-align: start">
                            {{ comment.Content }}
                          </div>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="_6cuq" v-show="qty_like > 0">
                <div>
                  <span class="container-count-like-comment">
                    <div class="a" role="button" tabindex="0">
                      <div class="b">
                        <div class="image-icon">
                          <img
                            class="comment-like-icon"
                            height="16"
                            src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 16 16'%3e%3cdefs%3e%3clinearGradient id='a' x1='50%25' x2='50%25' y1='0%25' y2='100%25'%3e%3cstop offset='0%25' stop-color='%2318AFFF'/%3e%3cstop offset='100%25' stop-color='%230062DF'/%3e%3c/linearGradient%3e%3cfilter id='c' width='118.8%25' height='118.8%25' x='-9.4%25' y='-9.4%25' filterUnits='objectBoundingBox'%3e%3cfeGaussianBlur in='SourceAlpha' result='shadowBlurInner1' stdDeviation='1'/%3e%3cfeOffset dy='-1' in='shadowBlurInner1' result='shadowOffsetInner1'/%3e%3cfeComposite in='shadowOffsetInner1' in2='SourceAlpha' k2='-1' k3='1' operator='arithmetic' result='shadowInnerInner1'/%3e%3cfeColorMatrix in='shadowInnerInner1' values='0 0 0 0 0 0 0 0 0 0.299356041 0 0 0 0 0.681187726 0 0 0 0.3495684 0'/%3e%3c/filter%3e%3cpath id='b' d='M8 0a8 8 0 00-8 8 8 8 0 1016 0 8 8 0 00-8-8z'/%3e%3c/defs%3e%3cg fill='none'%3e%3cuse fill='url(%23a)' xlink:href='%23b'/%3e%3cuse fill='black' filter='url(%23c)' xlink:href='%23b'/%3e%3cpath fill='white' d='M12.162 7.338c.176.123.338.245.338.674 0 .43-.229.604-.474.725a.73.73 0 01.089.546c-.077.344-.392.611-.672.69.121.194.159.385.015.62-.185.295-.346.407-1.058.407H7.5c-.988 0-1.5-.546-1.5-1V7.665c0-1.23 1.467-2.275 1.467-3.13L7.361 3.47c-.005-.065.008-.224.058-.27.08-.079.301-.2.635-.2.218 0 .363.041.534.123.581.277.732.978.732 1.542 0 .271-.414 1.083-.47 1.364 0 0 .867-.192 1.879-.199 1.061-.006 1.749.19 1.749.842 0 .261-.219.523-.316.666zM3.6 7h.8a.6.6 0 01.6.6v3.8a.6.6 0 01-.6.6h-.8a.6.6 0 01-.6-.6V7.6a.6.6 0 01.6-.6z'/%3e%3c/g%3e%3c/svg%3e"
                            width="16"
                          />
                        </div>
                        <span class="comment-message-like-count"
                          >{{ qty_like }}
                        </span>
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ul class="comment-message-actions">
          <li class="comment-message-action" v-show="false">
            <span aria-hidden="true" class="_6cok">&nbsp;·&nbsp;</span>
            <span>
              <div class="a">
                <span>
                  <div
                    @click="comment_like"
                    class="b"
                    role="button"
                    tabindex="0"
                  >
                    <div class="c"><span class="d"></span>Me gusta</div>
                  </div>
                </span>
              </div>
            </span>
          </li>

          <li class="comment-message-action">
            <span aria-hidden="true" class="_6cok">&nbsp;·&nbsp;</span>
            <a class="a2" href="#" role="link" tabindex="0">
              <span class="comment-message-create-at"
                >{{ formatDate(comment.CreatedAt, "LLL") }}
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </li>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { formatDate } from "@/utils";

export default {
  name: "CommentItem",
  props: {
    comment: {
      type: Object,
      default: () => {
        return {
          CreatedAt: "",
          Content: "",
          CreatedByUser: null
        };
      }
    },
    create_at: {
      type: String,
      default: "4 sem"
    },
    message: {
      type: String,
      default: "Mensaje"
    },
    qty_like: {
      type: Number,
      default: 0
    },
    crate_by_name: {
      type: String,
      default: "Creador"
    },
    crate_by_profile_img_src: {
      type: String,
      default: "/static/images/avatar-2.jpg"
    }
  },
  methods: {
    formatDate,
    ...mapActions({ add_like: "message/add_like" }),
    comment_like() {
      //
    }
  },
  computed: mapGetters({ loading: "message/isLoading" })
};
</script>

<style lang="scss" scoped>
.comment-item {
  padding-bottom: 0;
  position: relative;
  display: flex;
  padding-right: 16px;
  padding-top: 4px;
  padding-left: 16px;
  flex-direction: row;
  outline: none;

  .comment-item__perfil-image {
    border-bottom-left-radius: 50%;
    border-top-left-radius: 50%;
    margin-top: 2px;
    align-self: flex-start;
    position: relative;
    margin-right: 6px;
    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
    display: block;

    .nc684nl6 {
      display: inline;

      .comment-item__perfil-image__link {
        min-width: 0;
        min-height: 0;
        padding-top: 0;
        padding-left: 0;
        padding-right: 0;
        padding-bottom: 0;
        margin-bottom: 0;
        margin-top: 0;
        margin-left: 0;
        margin-right: 0;
        box-sizing: border-box;
        display: inline-block;
        flex-shrink: 0;
        cursor: pointer;
        flex-basis: auto;
        position: relative;
        text-align: inherit;
        align-items: stretch;
        background-color: transparent;
        touch-action: manipulation;
        z-index: 0;
        flex-direction: row;
        -webkit-tap-highlight-color: transparent;
        -webkit-user-select: none;
        border-left-width: 0;
        border-top-width: 0;
        border-right-width: 0;
        border-bottom-width: 0;
        border-bottom-style: solid;
        border-left-style: solid;
        border-top-style: solid;
        border-right-style: solid;
        border-right-color: rgba(0, 0, 0, 0.4);
        border-bottom-color: rgba(0, 0, 0, 0.4);
        border-left-color: rgba(0, 0, 0, 0.4);
        border-top-color: rgba(0, 0, 0, 0.4);
        list-style: none;
        outline: none;
        text-decoration: none;
      }
    }
  }

  .comment-item__view-comment {
    flex: 1;
    overflow-y: hidden;
    overflow-x: hidden;

    .comment-item__view-comment__message {
      vertical-align: middle;
      display: inline-block;
      word-wrap: break-word;
      max-width: calc(100% - 26px);

      .container-message-comment {
        box-sizing: border-box;
        word-break: break-word;
        border-bottom-left-radius: 18px;
        border-top-right-radius: 18px;
        display: inline-block;
        margin-bottom: 0;
        color: black;
        position: relative;
        white-space: normal;
        margin-top: 0;
        word-wrap: break-word;
        border-bottom-right-radius: 18px;
        margin-left: 0;
        border-top-left-radius: 18px;
        max-width: 100%;
        margin-right: 0;
        background-color: #edf1f3;

        .container-message-comment__c {
          padding-left: 12px;
          padding-bottom: 8px;
          padding-right: 12px;
          padding-top: 8px;

          .comment-link__profile-container {
            display: inline;

            .comment-link {
              padding-right: 0;
              box-sizing: border-box;
              padding-bottom: 0;
              -webkit-tap-highlight-color: transparent;
              cursor: pointer;
              display: inline;
              padding-top: 0;
              text-align: inherit;
              margin-left: 0;
              background-color: transparent;
              touch-action: manipulation;
              margin-right: 0;
              padding-left: 0;
              border-left: 0;
              border-top: 0;
              border-right: 0;
              border-bottom: 0;
              list-style: none;
              outline: none;
              text-decoration: none;

              &:hover {
                text-decoration: underline;
              }

              .pq6dq46d {
                display: inline-flex;
                .comment-link-name {
                  list-style: none;
                  -webkit-tap-highlight-color: transparent;
                  cursor: pointer;
                  text-align: inherit;
                  color: inherit;
                }
              }
            }
          }

          .comment-message__container {
            padding-top: 4px;
            padding-bottom: 4px;
            display: block;

            span {
              word-break: break-word;
              color: black;
              margin-top: -4px;
              font-weight: normal;
              font-size: 0.9375rem;
              -webkit-font-smoothing: antialiased;
              min-width: 0;
              margin-bottom: -4px;
              max-width: 100%;
              word-wrap: break-word;
              display: block;
              line-height: 1.3333;

              .message {
                margin-bottom: 0;
                margin-top: 0;
                margin-left: 0;
                margin-right: 0;
                word-wrap: break-word;
              }
            }
          }
        }
      }

      .container-count-like-comment {
        align-content: inherit;
        flex-basis: inherit;
        max-height: inherit;
        flex-grow: inherit;
        flex-shrink: inherit;
        max-width: inherit;
        flex-direction: inherit;
        width: inherit;
        min-height: inherit;
        min-width: inherit;
        justify-content: inherit;
        height: inherit;
        align-self: inherit;
        display: inherit;
        align-items: inherit;

        .a {
          padding-right: 0;
          box-sizing: border-box;
          padding-bottom: 0;
          margin-bottom: 0;
          margin-top: 0;
          -webkit-tap-highlight-color: transparent;
          cursor: pointer;
          display: inline;
          position: relative;
          padding-top: 0;
          text-align: inherit;
          margin-left: 0;
          background-color: transparent;
          touch-action: manipulation;
          margin-right: 0;
          -webkit-user-select: none;
          padding-left: 0;
          border-left: 0;
          border-top: 0;
          border-right: 0;
          border-bottom: 0;
          list-style: none;
          outline: none;
          text-decoration: none;

          .b {
            font-size: 0.6875rem;
            padding-bottom: 2px;
            border-bottom-left-radius: 10px;
            padding-right: 2px;
            padding-top: 2px;
            --T68779821: 0 1px 3px 0 #0003;
            -webkit-box-shadow: var(--T68779821);
            box-shadow: 0 1px 3px 0 #0003;
            display: flex;
            padding-left: 2px;
            background-color: #3a3b3c00;
            border-top-right-radius: 10px;
            border-bottom-right-radius: 10px;
            border-top-left-radius: 10px;
            align-items: center;

            .image-icon {
              flex-direction: row-reverse;
              padding-left: 4px;
              display: flex;
              align-items: center;

              .comment-like-icon {
                margin-left: -4px;
                border-bottom-left-radius: 10px;
                position: relative;
                border-top-right-radius: 10px;
                border-bottom-right-radius: 10px;
                border-top-left-radius: 10px;
                border-right: 2px solid #3e4042;
                border: 0;
                outline: none;
              }
            }

            .comment-message-like-count {
              padding-bottom: 0;
              padding-right: 2px;
              color: #303133;
              font-weight: normal;
              padding-top: 0;
              line-height: 1.2308;
              padding-left: 2px;
              white-space: nowrap;
              font-size: 0.8125rem;
            }
          }
        }
      }
    }

    .comment-message-actions {
      display: inline-block;
      font-size: 12px;
      line-height: 12px;
      color: #90949c;
      display: inline-block;
      font-size: 12px;
      line-height: 12px;
      padding-top: 3px;
      min-height: 15px;
      list-style-type: none;
      padding: 0;
      margin-left: 12px;

      .comment-message-action {
        display: inline-block;

        &:first-child ._6cok {
          display: none;
        }

        ._6cok {
          color: #8a8d91;
          margin-left: 2px;
        }

        .a {
          position: relative;
          display: inline-block;

          .b {
            min-height: 0;
            justify-content: center;
            padding-right: 0;
            box-sizing: border-box;
            padding-bottom: 0;
            flex-shrink: 0;
            margin-bottom: 0;
            -webkit-tap-highlight-color: transparent;
            cursor: pointer;
            flex-basis: auto;
            position: relative;
            margin-top: 0;
            padding-top: 0;
            display: flex;
            text-align: inherit;
            min-width: 0;
            margin-left: 0;
            touch-action: none;
            background-color: transparent;
            z-index: 0;
            margin-right: 0;
            flex-grow: 1;
            flex-direction: row;
            align-items: center;
            -webkit-user-select: none;
            padding-left: 0;
            border-right-color: #0006;
            border-left-width: 0;
            border-bottom-style: solid;
            border-top-width: 0;
            border-bottom-color: #0006;
            border-left-color: #0006;
            border-right-width: 0;
            border-top-color: #0006;
            border-left-style: solid;
            border-top-style: solid;
            border-right-style: solid;
            border-bottom-width: 0;
            list-style: none;
            outline: none;
            text-decoration: none;

            .c {
              display: inline-block;
              font-weight: bold;
              color: #b0b3b8;
              position: relative;
              cursor: pointer;

              &:hover {
                text-decoration: underline;
              }

              .d {
                display: inline-block;
                vertical-align: middle;
              }
            }
          }
        }

        .a2 {
          padding-right: 0;
          box-sizing: border-box;
          padding-bottom: 0;
          -webkit-tap-highlight-color: transparent;
          cursor: pointer;
          display: inline;
          color: #b0b3b8;
          font-weight: normal;
          padding-top: 0;
          text-align: inherit;
          margin-left: 0;
          background-color: transparent;
          touch-action: manipulation;
          margin-right: 0;
          padding-left: 0;
          border-left: 0;
          border-top: 0;
          border-right: 0;
          border-bottom: 0;
          list-style: none;
          outline: none;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }

          .comment-message-create-at {
            align-content: inherit;
            flex-basis: inherit;
            max-height: inherit;
            flex-grow: inherit;
            flex-shrink: inherit;
            max-width: inherit;
            flex-direction: inherit;
            width: inherit;
            min-height: inherit;
            min-width: inherit;
            justify-content: inherit;
            height: inherit;
            align-self: inherit;
            display: inherit;
            align-items: inherit;
          }
        }
      }
    }
  }
}

.avatar {
  border-radius: 50%;
  width: 35px;
  height: 35px;
  border: 1px solid #fff;
  margin-left: 20px;
  box-sizing: border-box;
  display: block;
  cursor: pointer;
  box-shadow: 0 2px 5px 0 rgba(49, 49, 93, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.5s;

  &:hover {
    box-shadow: 0px 3px 10px 0 rgba(49, 49, 93, 0.08),
      0px 2px 7px 0 rgba(0, 0, 0, 0.08);
  }
}

._680y {
  display: inline-flex;
  max-width: 100%;
  position: relative;
  vertical-align: middle;
}

._6cuy {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
}

._6cuq {
  bottom: -15px;
  position: absolute;
  right: 2px;
  z-index: 0;
}

.nc684nl6 {
  display: inline;
}
</style>
